<template>
  <div class="mt-5">
    <data-input
      v-if="floatingFilterOpened"
      v-on="listeners"
      @keyup.enter="onChangeEnterHandler"
      :data-type="dataType"
      :items="items"
      v-model="value"
      clearable
      style="max-width: 100%"
    >
    </data-input>
  </div>
</template>

<script>
import DataInput from '@/components/DataInput';
import { get } from 'vuex-pathify';

export default {
  name: 'TableFloatingFilter',
  components: {
    DataInput,
  },
  data: () => ({
    value: undefined,
  }),
  computed: {
    floatingFilterOpened: get('table/floatingFilterOpened'),
    listeners() {
      return {
        'click:clear': this.onClearClicked,
        ...(this.isSelect ? { input: this.onChange } : {}),
        ...(this.isDate ? { saveDate: this.onChange } : {}),
        ...(this.isBoolean ? { input: this.onChange } : {}),
      };
    },
    isBoolean() {
      return this.dataType?.name === 'boolean';
    },
    isDate() {
      return ['datetime', 'date', 'time'].includes(this.dataType?.name);
    },
    isSelect() {
      return this.dictValues || this.isRelational;
    },
    dataType() {
      if (this.isSelect) {
        return {
          name: 'select',
        };
      }
      return this.params.filterParams.colDef.dataType;
    },
    isRelational() {
      return this.params.filterParams.colDef.isRelational;
    },
    dictValues() {
      return this.params.filterParams.colDef.dictValues;
    },
    items() {
      return this.mapRelationalValues(this.params.filterParams.colDef.relationalValues) || this.dictValues;
    },
  },
  methods: {
    mapRelationalValues(dict) {
      if (!dict) {
        return;
      }
      if (Array.isArray(dict)) {
        return dict;
      }
      return Object.keys(dict).map(key => ({
        text: dict[key],
        value: key,
      }));
    },
    onChange(value) {
      if (this.isCleared) {
        this.isCleared = false;
        return;
      }
      if (value !== undefined && value !== null) {
        this.params.filterParams.context.contextParent.filters.headers_filter[this.params.column.colDef.field] = {
          value,
          type: this.isSelect ? '$EQUAL' : '$LIKE_CASE_INSENSITIVE',
        };
      } else {
        this.clearValue();
      }
      this.value = value;
      this.handleFilter();
    },
    onClearClicked() {
      this.isCleared = true;
      this.clearValue();
      this.handleFilter();
    },
    onChangeEnterHandler(e) {
      if (this.isSelect) {
        return;
      }
      this.onChange(e.target.value);
    },
    clearValue() {
      delete this.params.filterParams.context.contextParent.filters.headers_filter[this.params.column.colDef.field];
    },
    handleFilter() {
      this.params.filterParams.context.contextParent.handleFilter();
    },
  },
  mounted() {
    // floating filters had beend destroyed after scrolling over x axis and then value was cleared
    this.value = this.params.filterParams.context.contextParent.filters.headers_filter[
      this.params.column.colDef.field
    ]?.value;
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-select__selections {
  width: 0;
  min-width: 0;
}
</style>
